// extracted by mini-css-extract-plugin
export default {"list":"Socials_list__AJ6C1"};